var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ReportIssues" }, [
    _c(
      "span",
      {
        staticClass: "exclamation v-tooltip",
        on: {
          click: function($event) {
            _vm.isFormVisible = !_vm.isFormVisible
          }
        }
      },
      [
        _c("span", { staticClass: "v-tooltiptext" }, [
          _vm._v(
            "\n      Are you having trouble with the survey? Click here\n    "
          )
        ]),
        _vm._v(" "),
        _c("i", { staticClass: "fa fa-exclamation-triangle" })
      ]
    ),
    _vm._v(" "),
    _vm.isFormVisible
      ? _c(
          "form",
          {
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.handleSubmit.apply(null, arguments)
              }
            }
          },
          [
            _c("div", { staticClass: "title" }, [
              _vm._v(
                "\n      Are you having trouble with the survey? Please explain.\n    "
              )
            ]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.message,
                  expression: "message"
                }
              ],
              domProps: { value: _vm.message },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.message = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "flex" }, [
              _c(
                "button",
                {
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.isFormVisible = false
                    }
                  }
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c("input", {
                attrs: {
                  type: "submit",
                  disabled: _vm.loading || _vm.message === ""
                },
                domProps: { value: _vm.loading ? "Sending..." : "Send" }
              })
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c90ffca", { render: render, staticRenderFns: staticRenderFns })
  }
}